import { Country } from '~/Api/Country';
import { AeMaxPrice, ProductUpdate, ReferenceUpdate, ValidationResult } from '~/Api/User/ProductGroup/AeMaxPrice';

export enum ActionType {
	request = 'AeMaxPrice.request',
	receive = 'AeMaxPrice.receive',
	requestUpdate = 'AeMaxPrice.requestUpdate',
	receiveUpdate = 'AeMaxPrice.receiveUpdate',
	scheduleUpdate = 'AeMaxPrice.scheduleUpdate',
	requestXlsCreate = 'AeMaxPrice.requestXlsCreate',
	receiveXlsCreate = 'AeMaxPrice.receiveXlsCreate',
	prune = 'AeMaxPrice.prune',
	requestNationalities = 'AeMaxPrice.requestNationalities',
	receiveNationalities = 'AeMaxPrice.receiveNationalities',
	pruneNationalities = 'AeMaxPrice.pruneNationalities',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.request;
}

export interface ReceiveAction {
	groupId: string;
	aeMaxPrice: AeMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receive;
}

export interface ScheduleUpdateAction {
	groupId: string;
	products: ProductUpdate[];
	reference: ReferenceUpdate;
	timeoutId: NodeJS.Timeout;
	type: ActionType.scheduleUpdate;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	aeMaxPrice: AeMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receiveUpdate;
}

export interface RequestXlsCreateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestXlsCreate;
}

export interface ReceiveXlsCreateAction {
	request: Promise<any>;
	type: ActionType.receiveXlsCreate;
	validationResult: ValidationResult | null;
}

export interface PruneAction {
	groupId: string;
	type: ActionType.prune;
}

export interface RequestNationalitiesAction {
	type: ActionType.requestNationalities;
	request: Promise<any>;
}

export interface ReceiveNationalitiesAction {
	type: ActionType.receiveNationalities;
	request: Promise<any>;
	items: Country[] | null;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| RequestXlsCreateAction
	| ReceiveXlsCreateAction
	| RequestNationalitiesAction
	| ReceiveNationalitiesAction
	| PruneAction;
